// extracted by mini-css-extract-plugin
export default {"app":"LoginForm_app__5aRPP","form":"LoginForm_form__nb9BN"};